// Phase 2 §3: Scenario Projection Banner
// Warning banner displayed when in Scenario Mode

import { AlertTriangle, X } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { useProjectionMode } from '@/hooks/useProjectionMode';
import { useState } from 'react';

export function ScenarioProjectionBanner() {
  const { isScenarioMode, setMode } = useProjectionMode();
  const [dismissed, setDismissed] = useState(false);

  if (!isScenarioMode || dismissed) return null;

  return (
    <Alert className="fixed top-0 left-0 right-0 z-50 rounded-none border-b-2 border-warning-foreground bg-warning text-warning-foreground shadow-md">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5" />
          <AlertDescription className="font-semibold">
            SCENARIO MODE - Projection Data Only (Not Legal Record)
          </AlertDescription>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setMode('LEGAL')}
            className="border-warning-foreground text-warning-foreground hover:bg-warning-foreground hover:text-warning"
          >
            Switch to Legal
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setDismissed(true)}
            className="text-warning-foreground hover:bg-warning-foreground hover:text-warning"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {/* Diagonal watermark */}
      <div
        className="absolute inset-0 pointer-events-none overflow-hidden"
        style={{
          backgroundImage:
            'repeating-linear-gradient(45deg, transparent, transparent 100px, rgba(0,0,0,0.03) 100px, rgba(0,0,0,0.03) 200px)',
        }}
      >
        <div className="absolute inset-0 flex items-center justify-center opacity-5">
          <span className="text-9xl font-bold rotate-[-45deg] select-none">PROJECTION</span>
        </div>
      </div>
    </Alert>
  );
}
